<template>
  <div class="md-layout">
    <div class="filters kiosk_activity md-layout-item md-size-100">
      <md-card v-if="inactive_kiosks && inactive_kiosks.length" class="inactiveKiosk">
        <h3 class="inactiveHeader">
          {{inactive_kiosks.length}} Kiosks Offline
          <span
            class="refresh"
            @click="formatInactiveKiosks()"
          >refresh</span>
        </h3>
        <div class="view-all">
          <md-button
            @click="show_inactive_kiosks = !show_inactive_kiosks"
            class="inactive-btn inactiveTab"
          >{{show_inactive_kiosks ? 'Hide All' : 'View All'}}</md-button>
        </div>
        <transition name="fade">
          <div class="inactive" v-if="show_inactive_kiosks">
            <div v-for="(kiosk, index) in inactive_kiosks" :key="index" class="active_kiosks">
              <md-button
                @click.native="openKioskDetails(kiosk.id)"
                class="inactive-btn inactiveTab"
              >
                {{ kiosk.name }}
                <span>{{ kiosk.duration }}</span>
              </md-button>
            </div>
          </div>
        </transition>
      </md-card>
      <md-card v-else class="stat online">
        <h3>All Screens are Online</h3>
      </md-card>
    </div>

    <div class="filters md-layout-item md-size-100">
      <md-card class="stat">
        <div class="filter">
          <label>Start Date</label>
          <md-datepicker
            :md-disabled-dates="disabledDates"
            class="filter-date"
            v-model="startDate"
          />
        </div>
        <div class="filter">
          <label>End Date</label>
          <md-datepicker :md-disabled-dates="disabledDates" class="filter-date" v-model="endDate" />
        </div>
        <!-- <div class="filter" v-if="filter_distance > 13 && filter_distance < 50">
          <label>Show by Days</label>
          <md-switch v-model="filter_choice" value="days"></md-switch>
        </div>
        <div class="filter" v-if="filter_distance > 13">
          <label>Show by Weeks</label>
          <md-switch v-model="filter_choice" value="weeks"></md-switch>
        </div>
        <div class="filter" v-if="filter_distance > 60">
          <label>Show by Months</label>
          <md-switch v-model="filter_choice" value="months"></md-switch>
        </div>-->
        <div class="filter_button">
          <md-button @click="fetchNewAnalytics">Filter</md-button>
        </div>
      </md-card>
    </div>
    <div class="stats-holder">
      <div class="requests md-layout-item md-size-100">
        <md-card class="stat blue total">
          <h2>
            {{ total_requests ? total_requests : '00' }}
            <span>
              Total Fragrances Used
              <span v-if="chart1_load">loading...</span>
            </span>
          </h2>
        </md-card>
        <md-card class="stat requests_sent">
          <h3>
            Fragrances Used
            <span @click="$router.push({ path: '/leads' })" class="cta">view details</span>
          </h3>
          <div class="chart ct-chart home-page-clicks"></div>
          <img v-if="chart1_load" class="loader" src="@/assets/img/loader.gif" />
        </md-card>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card class="stat">
        <h3>Fragrences Used per Screen</h3>
        <div class="category-clicks">
          <div v-for="(clicks, index) in category_clicks" :key="index" class="category-click">
            <p>
              <span class="num">
                {{ clicks.count }}
                <span>Sprays</span>
              </span>
              {{ clicks.name }}
            </p>
          </div>
          <img v-if="chart2_load" class="loader" src="@/assets/img/loader.gif" />
        </div>
      </md-card>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
// import AsyncWorldMap from "@/components/WorldMap/AsyncWorldMap.vue";
// import { StatsCard, AnimatedNumber } from "@/components";
import * as queries from "../../helpers/queries.js";
import * as mappers from "../../helpers/mappers.js";
import router from "@/router";

const moment = require("moment-timezone");

export default {
  components: {
    // StatsCard,
    // AnimatedNumber
  },
  data() {
    return {
      show_inactive_kiosks: false,
      chart1_load: true,
      chart2_load: true,
      startDate: moment(Date.now())
        .subtract(8, "days")
        .format("YYYY-MM-DD"),
      endDate: moment(Date.now())
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      filter_labels: {
        day: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        month: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      filter_distance: 7,
      filter_choice: [],
      total_requests: null,
      category_clicks: [
        {
          count: 0,
          name: "Screen Name"
        }
      ],
      inactive_kiosks: null
    };
  },
  created() {
    db.collection("inactive_kiosk")
      .doc("all")
      .onSnapshot(doc => {
        this.inactive_kiosks = doc.data().kiosks;
      });
  },
  mounted() {
    this.$nextTick(async () => {
      this.formatInactiveKiosks();
      this.chart2_load = false;
      this.createCharts();
    });
  },
  methods: {
    formatInactiveKiosks() {
      functions.httpsCallable("getInactiveKiosks")();
    },
    openKioskDetails(kioskId) {
      let id = kioskId;
      router.push(`/kiosks/${id}`);
    },
    createCharts() {
      this.initiateChart();
      this.initiateRequestsChart();
    },
    async initiateChart() {
      new Chartist.Line(
        ".ct-chart",
        {
          labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          series: [
            [12, 9, 7, 8, 5],
            [2, 1, 3.5, 7, 3],
            [1, 3, 4, 5, 5],
            [1, 3, 4, 5, 2],
            [10, 15, 25, 22, 19]
          ]
        },
        {
          fullWidth: true,
          height: 400,
          chartPadding: {
            right: 40
          }
        }
      );
      this.chart1_load = false;
    },
    async initiateRequestsChart() {
      let getDestinationRequest = functions.httpsCallable("getAnalytics");

      let destinationRequests = await getDestinationRequest({
        query: queries.getDestinationRequestBetweenTimestamps(
          this.startDate,
          this.endDate
        )
      }).then(res => {
        return res.data;
      });

      this.total_requests = destinationRequests.length;

      let data = mappers.destinationRequestMapper(
        destinationRequests,
        this.startDate,
        this.endDate
      );

      let totalXAxis = moment(this.endDate).diff(
        moment(this.startDate),
        "days"
      );

      let skipXAxis = Math.floor(totalXAxis / 7);

      new Chartist.Line(".ct-chart2", data, {
        low: 0,
        showArea: true,
        axisX: {
          labelInterpolationFnc: function(value, i) {
            if ((i + 1) % skipXAxis == 0) return value;
          }
        }
      });
      this.chart2_load = false;
    },
    disabledDates(date) {
      if (moment(date).isAfter(moment(Date.now()))) return true;
      else return false;
    },
    goTo(url) {
      this.$router.push({ path: "/" + url });
    },
    isOffline(k) {
      if (!k.lastSignal) {
        return true;
      } else {
        const now = moment.tz(Date.now(), "America/New_York");
        const then = moment.tz(k.lastSignal, "America/New_York");
        const duration = moment.duration(now.diff(then));
        const mins = duration.asMinutes();
        // console.log(k.name +': '+mins)
        if (mins > 20) {
          return true;
        } else {
          return false;
        }
      }
    },
    fetchNewAnalytics() {
      this.chart1_load = this.chart2_load = this.chart3_load = true;
      let charts = document.getElementsByClassName("chart");
      for (var i = 0; i < charts.length; i++) {
        charts[i].children[0].remove();
      }
      this.category_clicks = [];
      this.$nextTick(async () => {
        let getCategoryClicks = functions.httpsCallable("getAnalytics");
        let categoryClicks = await getCategoryClicks({
          query: queries.getCategoryClicksBetweenTimestamps(
            this.startDate,
            this.endDate
          )
        }).then(res => {
          return res.data;
        });
        this.category_clicks = mappers.categoryClicksMapper(categoryClicks);
        this.chart3_load = false;
        this.createCharts();
      });
    }
  },
  watch: {
    startDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);
      this.filter_distance = end.diff(start, "days");
    },
    endDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);
      this.filter_distance = end.diff(start, "days");
    },
    filter_choice() {
      if (this.filter_choice.length > 1) this.filter_choice.shift();
    }
  }
};
</script>

<style type="text/css">
.img-card {
  height: 48vh;
  min-height: 300px;
  background-size: cover;
  position: relative;
  border: 10px solid #f5f4f2;
}

.img-card .dark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
}
.img-card .contain {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  height: 100%;
  padding: 30px;
}

.img-card h2 {
  color: white;
  font-size: 20px;
  margin: 0;
  font-weight: bold;
}

.img-card h1 {
  color: white;
  margin: 0;
  font-size: 100px;
}

.img-card h1 span {
  font-size: 20px;
  margin-left: -20px;
}

.stats-holder {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
}

.stat {
  padding: 30px;
  box-sizing: border-box;
  padding-bottom: 10px;
}

@media screen and (max-width: 500px) {
  .stat {
    padding: 10px;
  }

  .stat h3 {
    padding: 0 20px;
    margin-top: 20px;
  }

  .stat .legend {
    padding: 0 20px;
  }
}

.stat h3 {
  margin: 0;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.stat h3 span.cta {
  margin-left: 30px;
  color: #3581ef;
  font-size: 15px;
  cursor: pointer;
  font-weight: normal;
  transition: color 0.3s;
}

.stat h3 span.cta:hover {
  color: #134b9d;
}

.home-page-clicks .ct-series-a .ct-bar {
  stroke: #3581ef;
}

.home-page-clicks .ct-series-b .ct-bar {
  stroke: #f44336;
}

.ct-bar {
  stroke-width: 5px;
}

.legend {
  display: flex;
  flex-direction: column;
}

.legend .key {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.legend .key .color {
  height: 10px;
  width: 10px;
  margin-right: 7px;
}

.legend .key p {
  margin: 0;
}

.chart {
  margin-top: 30px;
}

.chart1 {
  height: 100%;
  margin: 0 !important;
}

.ct-chart1 {
  height: 250px;
}

.ct-chart2 .ct-series-a .ct-area {
  fill: rgba(53, 129, 239, 0.28);
}

.ct-chart2 .ct-series-a .ct-point,
.ct-series-a .ct-line {
  stroke: #3581ef;
}

.blue {
  background: #3581ef !important;
}
.online {
  padding: 10px 20px !important;
  background: #52e892 !important;
  margin-bottom: 10px;
}

.online h3 {
  color: white;
  margin-bottom: 0 !important;
  font-size: 17px;
}
.requests .md-card {
  margin: 0 !important;
}

.md-card.blue {
  padding: 20px 30px;
  margin-bottom: 15px !important;
}

.md-card.blue h2 {
  color: white;
  margin: 0;
}

.md-card.blue h2 span {
  font-size: 20px;
}

.category-clicks {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 150px;
}

@media screen and (max-width: 800px) {
  .stats-holder {
    flex-wrap: nowrap;
    flex-direction: column;
  }

  .main-categories {
    margin-bottom: 15px;
  }

  .stats-holder .md-layout-item {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.category-clicks .category-click {
  width: 200px;
  margin-right: 20px;
}

.category-clicks .category-click p {
  display: flex;
  flex-direction: column;
}

.category-clicks .category-click p span.num {
  color: #3581ef;
  font-weight: bold;
  font-size: 20px;
}

.category-clicks .category-click p span.num span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 0;
}

.filters {
  margin: 0 !important;
  margin-bottom: 15px !important;
}

.filters .md-card {
  margin-bottom: 0 !important;
}

.filter-date {
  max-width: 160px;
  overflow: hidden;
  background: #f7f7f7;
  padding-bottom: 0;
}

.filter-date input {
  margin-left: 0 !important;
}

.filters .stat {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
}

.filters .stat .filter {
  margin-right: 20px;
}

.md-datepicker-dialog .md-datepicker-header {
  background: #134b9d !important;
}

.md-datepicker-body-header .md-button.md-theme-default,
.md-datepicker-body-content .md-button.md-theme-default {
  background: #f7f7f7 !important;
}

.md-datepicker-dialog.md-theme-default
  .md-datepicker-day-button.md-datepicker-selected,
.md-datepicker-selected {
  background: #3581ef !important;
}

.md-datepicker-today {
  background-color: rgba(53, 129, 239, 0.28) !important;
  color: black !important;
}

.filter_button {
  padding: 20px;
}

.requests_sent {
  min-height: 250px;
}

.stat .loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end,
.ct-label.ct-horizontal.ct-end {
  padding-top: 7px;
}

.ct-chart2 .ct-label.ct-horizontal.ct-end {
  transform: translateX(-50%);
  text-align: center;
  justify-content: center;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end::before,
.ct-label.ct-horizontal.ct-end::before {
  content: "";
  position: absolute;
  left: 50%;
  height: 2px;
  transform: translateX(-50%);
  width: 10px;
  background: #d5d5d5;
  top: 0;
}

.inactive {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.inactiveKiosk {
  padding-left: 30px;
  background-color: #f44336 !important;
  margin-bottom: 10px;
}

.active_kiosks {
  margin-bottom: 0;
}

.filters.kiosk_activity {
  margin-bottom: 3px !important;
}
.inactiveHeader {
  color: white;
  font-size: 18px;
  margin-bottom: 0px;
  margin-top: 20px;
}

.filters h3 {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-right: 20px !important;
}
.filters h3 .refresh {
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
}

.inactive-btn .md-ripple {
  padding: 10px 20px !important;
}

.inactive-btn .md-button-content {
  display: flex;
  font-weight: bold;
  font-size: 15px;
  text-transform: initial;
  flex-direction: column;
  align-items: flex-start;
}

.inactive-btn .md-button-content span {
  font-weight: normal;
  font-size: 13px;
}

.view-all {
  width: 100%;
}

.md-layout-item.md-size-100.requests {
  display: flex;
  flex-direction: row !important;
  flex-wrap: nowrap;
}
.md-card.blue.total {
  max-width: 300px;
  margin-right: 20px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.md-card.blue.total h2 {
  text-align: center;
}

.md-card.blue.total span {
  display: block;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end::before,
.ct-label.ct-horizontal.ct-end::before {
  left: 0 !important;
  transform: none;
}
</style>
